import { Component } from '@angular/core';

@Component({
  selector: 'app-translate-result-dialog',
  standalone: true,
  template: `
    <div class="image-dialog">
      <img [src]="'assets/tr.svg'" alt="Result preview" class="dialog-image"/>
    </div>
  `,
  styles: [`
    .image-dialog {
      padding: 0;
      text-align: center;
    }
    .dialog-image {
      max-width: 100%;
      max-height: 80vh;
      border-radius: 8px;
    }
  `]
})
export class TranslateResultDialogComponent {
}
